import {
  createCigamIntegrationAsync,
  deleteCigamIntegrationAsync,
  getCigamIntegrationByIdAsync,
  updateCigamIntegrationAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateCigamIntegrationAsync = () =>
  useMutation(createCigamIntegrationAsync);

export const useGetCigamIntegrationByIdAsync = () =>
  useMutation(getCigamIntegrationByIdAsync);

export const useUpdateCigamIntegrationAsync = () =>
  useMutation(updateCigamIntegrationAsync);

export const useDeleteCigamIntegrationAsync = () =>
  useMutation(deleteCigamIntegrationAsync);
